var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalerie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-436 -231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508 302.6 494.31 280.78C494.065 280.38 493.629 280.137 493.16 280.14 492.689 280.14 492.251 280.382 492 280.78L488 287.2 496.58 301.08C497.306 302.178 497.462 303.557 497 304.79L506.7 304.79C507.494 304.83 508.17 304.218 508.21 303.424 508.224 303.134 508.151 302.847 508 302.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.1 302.73 471.35 267.34C471.071 266.979 470.636 266.775 470.18 266.79L470 266.79 469.82 266.79C469.364 266.775 468.929 266.979 468.65 267.34L446.9 302.73C446.592 303.161 446.549 303.728 446.79 304.2 447.033 304.628 447.513 304.862 448 304.79L492 304.79C492.487 304.862 492.967 304.628 493.21 304.2 493.451 303.728 493.408 303.161 493.1 302.73ZM473.64 283.92 470.18 287 466.72 283.92 461 287.38 470 272.79 478.76 287Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 269C460 270.657 458.657 272 457 272 455.343 272 454 270.657 454 269 454 267.343 455.343 266 457 266 458.657 266 460 267.343 460 269Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529 244 449 244 449 255 438 255 438 316.79 518 316.79 518 305.79 529 305.79ZM512 311 444 311 444 260.79 512 260.79ZM523 300 518 300 518 255 455 255 455 250 523 250Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalerie);
export default __webpack_public_path__ + "static/media/Galerie.4c9d433bbd55e364b9732c892a0156f3.svg";
export { ForwardRef as ReactComponent };